import localReducer from './reducer'
import { NAME } from './constants'
import { action } from './actions.js'

import Cell from './component/Cell'
import createDropDownEditor from './component/createDropDownEditor'
import GenericModal from './component/GenericModal'
import ErrorModal from './component/ErrorModal'
import {
  GenericScreen as SimpleScreen,
  RetrieveOnlyCriteria as RetrieveCriteria,
} from '@integec/common-react-screens/lib/generic-view'

import Overlay from './component/Overlay'
import DatePicker from './component/DatePicker'
import UnitSelection from './component/UnitSelection'
// import ExportComponent from './component/ExportComponent'
import ExportComponent from './component/ExportComponentsExcel'
import EditableGrid from './component/EditableGrid'
import UtilityUnitSelection from './component/UtilityUnitSelection'
import StationSelection from './component/StationSelection'

const reducers = {
  [NAME]: localReducer,
}

export {
  reducers,
  NAME,
  action,
  Cell,
  createDropDownEditor,
  GenericModal,
  ErrorModal,
  RetrieveCriteria,
  SimpleScreen,
  Overlay,
  UnitSelection,
  ExportComponent,
  DatePicker,
  EditableGrid,
  UtilityUnitSelection,
  StationSelection,
}

export * from './selectors'
export * from './utils'

export default {
  reducers,
  NAME,
  action,
}
